export const EMAIL_FORMAT = '請輸入正確的信箱格式';
export const PASSWORD_FORMAT = '請輸入六碼以上的密碼';